import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import Spinner from '../../Spinner/Spinner';
import "./homenews.css"

export const HomeNews = () => {

  const { id } = useParams();
   
  const [ndata, setNdata] = useState([])
  const [loading, setLoading] = useState(true)


  
 



  const getNews = async () => {
    setLoading(true)
    const response = await fetch("https://nairalandclone.herokuapp.com/api/home");
    const data = await response.json()
    setNdata(data)
    setLoading(false)
    console.log(data, ndata)
   }

  useEffect(() => {
    getNews()
  },[])

  return (
    <div className='homenews'><div className="top"><img src={require("../../photos/smiley.gif")} alt="" />{' '} Latest News {' '}/{' '}Twitter{' '}/{' '}Facebook{' '}/{' '}How To Advertise {' '}<img src={require("../../photos/smiley.gif")} alt="" /></div>
      <div className="news">
        {
         loading ? <div className="spinn"><Spinner /></div>  :( ndata.map(data => { const UrlEncode = encodeURIComponent(data.urls); return (<div>&#187; <Link className='newtopics' to={`/open/${UrlEncode}`} dangerouslySetInnerHTML={{__html: data.title }}/> &#171;</div>)} ) )
        }
        
        
      </div>
      <div className="bottom">
       <Link to="/"> (1) </Link>&nbsp; <Link  to="/newpage/2"> (2) </Link> &nbsp; <Link  to="/newpage/3"> (3) </Link>&nbsp; <Link  to="/newpage/4"> (4) </Link>&nbsp; <Link  to="/newpage/5"> (5) </Link> <Link  to="/newpage/6"> (6) </Link>&nbsp; <Link  to="/newpage/7"> (7) </Link> &nbsp;<Link  to="/newpage/8"> (8) </Link>&nbsp; <Link  to="/newpage/9"> (9) </Link> &nbsp;<Link  to="/newpage/10"> (10) </Link> 
      </div>
     
    </div>
  )
}